import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
import en from './locales/en.json';
import ru from './locales/ru.json';
import uk from './locales/uk.json';
import az from './locales/az.json';
import kk from './locales/kk.json';
import uz from './locales/uz.json';
import tr from './locales/tr.json';
import de from './locales/de.json';
import fr from './locales/fr.json';
import es from './locales/es.json';
import it from './locales/it.json';
import pt from './locales/pt.json';
import pl from './locales/pl.json';
import cs from './locales/cs.json';
import ro from './locales/ro.json';
import sk from './locales/sk.json';
import da from './locales/da.json';
import bg from './locales/bg.json';
import ja from './locales/ja.json';
import ko from './locales/ko.json';
import zh from './locales/zh.json';
import vi from './locales/vi.json';

const resources = {
  en: { translation: en },
  ru: { translation: ru },
  uk: { translation: uk },
  az: { translation: az },
  kk: { translation: kk },
  uz: { translation: uz },
  tr: { translation: tr },
  de: { translation: de },
  fr: { translation: fr },
  es: { translation: es },
  it: { translation: it },
  pt: { translation: pt },
  pl: { translation: pl },
  cs: { translation: cs },
  ro: { translation: ro },
  sk: { translation: sk },
  da: { translation: da },
  bg: { translation: bg },
  ja: { translation: ja },
  ko: { translation: ko },
  zh: { translation: zh },
  vi: { translation: vi }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
